"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.regExTypeDate = exports.regExTypeDateTime = void 0;
exports.assertDateVariant = assertDateVariant;
exports.normalizeUnit = normalizeUnit;
exports.isLocalDate = isLocalDate;
exports.isLocalDateTime = isLocalDateTime;
exports.isZonedDateTime = isZonedDateTime;
exports.isLocalDateOrZonedDateTime = isLocalDateOrZonedDateTime;
exports.isSpaDate = isSpaDate;
exports.getMoment = getMoment;
const tslib_1 = require("tslib");
const moment_timezone_1 = tslib_1.__importDefault(require("moment-timezone"));
exports.regExTypeDateTime = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(?:.(\d{3}))?/;
exports.regExTypeDate = /^(\d{4})-(\d{2})-(\d{2})$/;
function assertDateVariant(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
val, msg) {
    if (isSpaDate(val) ||
        typeof val === 'string' ||
        val instanceof Date ||
        moment_timezone_1.default.isMoment(val)) {
        if (typeof val === 'string') {
            if (exports.regExTypeDateTime.test(val) || exports.regExTypeDate.test(val)) {
                return;
            }
        }
        else {
            return;
        }
    }
    throw Error(msg || `assert DateVariant but was type ${typeof val} and value ${val}`);
}
function normalizeUnit(unit) {
    if (unit === 'week') {
        return 'isoWeek';
    }
    return unit;
}
function isLocalDate(item) {
    return (item === null || item === void 0 ? void 0 : item.__type__) === 'date';
}
function isLocalDateTime(item) {
    return (item === null || item === void 0 ? void 0 : item.__type__) === 'local-datetime';
}
function isZonedDateTime(item) {
    return (item === null || item === void 0 ? void 0 : item.__type__) === 'datetime';
}
/**
 * @deprecated use isSpaDate instead
 */
function isLocalDateOrZonedDateTime(item) {
    return isLocalDate(item) || isZonedDateTime(item);
}
function isSpaDate(item) {
    return isLocalDate(item) || isLocalDateTime(item) || isZonedDateTime(item);
}
function getMoment(date, options) {
    const newDate = (() => {
        if (typeof date === 'string' ||
            typeof date === 'number' ||
            date instanceof Date ||
            moment_timezone_1.default.isMoment(date)) {
            return (0, moment_timezone_1.default)(date, options.format);
        }
        if (isSpaDate(date)) {
            return date.toMoment();
        }
        throw new Error(`date '${date}' not supported.`);
    })();
    const momentInstance = options.timezone
        ? newDate.tz(options.timezone)
        : newDate;
    if (options.locale) {
        momentInstance.locale(options.locale);
    }
    return momentInstance;
}
